import { SendDraftCardView } from '@/components/blocks/Message/SendDraftCardView';
import { useSendDraftCard } from '@/features/integrations/useSendDraftCard';

export interface SendDraftCardProps {
  draftId: string;
  toolkitName: string;
  accountLabel?: string;
  defaultEditing?: boolean;
  onSent?: () => void;
  onSaved?: () => void;
  onEditCancelled?: () => void;
}

export function SendDraftCard(props: SendDraftCardProps) {
  return (
    <SendDraftCardView draftId={props.draftId} {...useSendDraftCard(props)} />
  );
}
